import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyB-u5fSGKipc133NBrZIZKf2SYf5mDQdY8',
  authDomain: 'music-5e574.firebaseapp.com',
  projectId: 'music-5e574',
  storageBucket: 'music-5e574.appspot.com',
  appId: '1:4683926768:web:4e3e6bad9edc2eff4a4635',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

// will inform firebase to keep a copy of the db in the users browser
db.enablePersistence().catch((err) => {
  console.log('Firebase persistence error', err.code);
});

const usersCollection = db.collection('users');
const songsCollection = db.collection('songs');
const commentsCollection = db.collection('comments');

export {
  auth,
  db,
  usersCollection,
  songsCollection,
  commentsCollection,
  storage,
};
